import * as API from "@/store/actions/axios-api-instance";

export default async function signUp({state, commit, dispatch}, {email, password}) {
    try {
        commit('SET_LOADING', true)
        const auth = await API.signUp(email, password)
        commit('SET_TOKEN', auth.token)
        localStorage.setItem('token', auth.token)

        await dispatch('getProfile')
        await dispatch('getConfig', state.profile.product)
        await dispatch('getLicense')
        commit('SET_LOADING', false)
    } catch (e) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', 'Unable to sign up')
        console.log(e)
        throw e
    }
}